import { createSelector } from 'reselect';

const iecData = (state) => state.iecmodule.IECdata;
const AddIECModuleData = (state) => state.iecmodule.formData;
const updatedData = (state) => state.iecmodule.data;
const selectedItems = (state) => state.iecmodule.selectedItems;
export const getIecData = createSelector([iecData], (data) => data);
export const getIECModuleData =createSelector([AddIECModuleData],(data)=>data);
export const getUpdatedData = createSelector(
    [updatedData],
    (data) => data
  );
export const getSelectedItems = createSelector(
  [selectedItems],
  (items) => items
);
